import React, { useEffect } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { useEnquiryModal } from "./EnquiryModal";
import Navbar from "./Navbar";
import FirstTimeBuyer from "./Homebuyer";
import FooterMain from "./FooterMain";
import { Projects } from "./Projects";
import { IoCheckmarkCircleSharp } from "react-icons/io5";

export default function PropertyCarousel() {
  const navigate = useNavigate();
  const { openModal } = useEnquiryModal();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCardClick = (property) => {
    navigate(`/property/${property.url}`, { state: property });
  };

  return <>
    <Navbar />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
      <div className="flex flex-col sm:flex-row justify-between items-center md:mb-6 mb-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#000000] text-center sm:text-left">
          Golden Visa Properties
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Projects.map((p) => {

          // --- Types compute logic ---
          let types = [];
          if (p.type) {
            if (p.type.includes("&")) {
              types = p.type.split("&").map(t => t.trim());
            } else {
              types.push(p.type);
            }
          }

          return (
            <div
              key={p.id}
              onClick={() => handleCardClick(p)}
              className="cursor-pointer bg-white rounded-xl overflow-hidden shadow hover:shadow-lg transition transform hover:-translate-y-1"
            >
              <div className="relative">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-56 object-cover hover:scale-110 transition-transform duration-300"
                />

                <div className="absolute flex flex-col top-2 left-2 gap-2">
                  <div className="flex gap-2 flex-wrap">
                    {types.map((t, i) => (
                      <span
                        key={i}
                        className="bg-white text-[#003153] text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <span className="bg-[#003153] text-white text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap inline-block max-w-[116px] overflow-hidden text-ellipsis">
                    {p.plan}
                  </span>
                </div>
              </div>

              <div className="p-5">
                <h3 className=" text-3xl leading-[32px] font-semibold text-[#003153] mb-3 ">
                  {p.price}
                </h3>
                <p className="text-xl mb-0.5 font-medium">{p.title}</p>
                <h2 className="text-md flex mb-3 items-center text-black">By {p.developer}</h2>

                <p className="text-[#003153] text-sm flex items-center">
                  <i className="fa-solid text-[#003153] fa-location-dot mr-1"></i> {p.location}
                </p>

                <div className="mt-1 border-t pt-4">
                  <div className="flex items-center gap-3">
                    {p.agentImg && (
                      <img
                        src={p.agentImg}
                        alt={p.agent}
                        className="w-16 h-20 rounded-md border"
                      />
                    )}
                    <div>
                      <p className="text-xs text-gray-600">Our Expert</p>
                      <p className="text-md flex gap-1 font-semibold text-gray-800">
                        {p.agent}
                        <span className="text-xs justify-content-center items-center flex">
                          <IoCheckmarkCircleSharp className="text-green-500 mr-1" size={12} /> RERA verified
                        </span>
                      </p>
                      <p className="text-sm font-semibold text-gray-800">{p.experience}</p>
                    </div>
                  </div>
                </div>

                <button
                  onClick={(e) => {
                    e.stopPropagation(); // card click prevent
                    openModal({
                      projectTitle: p.project_name || p.title,   // THIS IS IMPORTANT
                      projectId: p.id,
                    });
                  }}
                  className="w-full bg-[#003153] text-white font-semibold py-2 rounded-lg mt-4 hover:bg-[#003153]/80 transition"
                >
                  Enquire Now
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
    <FirstTimeBuyer />
    <FooterMain />
  </>;

}
